import { DocumentConsent } from '@components/document-consent/document-consent';
import { useAccountApplication, useAccountApplicationActions } from '@hooks/context/use-account-application-context';
import { useLinks } from '@hooks/use-links';
import { useCreateProcess } from '@react-query/hooks/mutation/use-create-process';
import { useTranslation } from '@translations';
import { isEmptyEmail, validEmail } from '@utils/email-validate-utils';
import { isValidAccountApplication } from '@utils/process-form-utils';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getProcessPayloadFromAccountApplication } from './utils';

export const ApplicantDocumentConsent = () => {
    const { next, processSummary } = useTranslation();
    const accountApplication = useAccountApplication();
    const navigate = useNavigate();
    const { nextStep } = useLinks();
    const { setApplicantParentHasGivenConsent } = useAccountApplicationActions();
    const { mutate: createProcess, isPending, isSuccess, error } = useCreateProcess();

    const [formError, setFormError] = useState<string | undefined>(undefined);

    const onSubmit = () => {
        if (!accountApplication.applicantParentEmail || isEmptyEmail(accountApplication.applicantParentEmail)) {
            setFormError(processSummary.email.emptyEmailError);
            return;
        }

        if (!validEmail(accountApplication.applicantParentEmail)) {
            setFormError(processSummary.email.invalidEmailError);
            return;
        }

        if (!isValidAccountApplication(accountApplication)) {
            setFormError(processSummary.invalidProcessSubmitted);
            return;
        }

        setFormError(undefined);

        const payload = getProcessPayloadFromAccountApplication(accountApplication);

        createProcess(payload, {
            onSuccess: (response) => {
                navigate(`${nextStep.url}/${response.id}`);
            },
        });
    };

    return (
        <DocumentConsent>
            <DocumentConsent.Documents />
            <DocumentConsent.ConfirmCheckBox onValueChange={setApplicantParentHasGivenConsent} />
            <DocumentConsent.SubmitButton
                onSubmit={onSubmit}
                showSpinner={isPending}
                showSuccess={isSuccess}
                buttonText={next}
            />
            <DocumentConsent.FormError formError={formError} />
            <DocumentConsent.SubmitError error={error} />
        </DocumentConsent>
    );
};
